import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Button, message, Card, Modal, Typography } from "antd";
import axiosInstance from "../../utils/axiosInstance";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";

const { Title, Paragraph } = Typography;

const ApproveAgreementPage = () => {
  const { token } = useParams(); 
  const [loading, setLoading] = useState(false);
  const [approved, setApproved] = useState(false);
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [remark, setRemark] = useState("");

  const handleApprove = async (action, remarkValue = "") => {
    setLoading(true);
    try {
      await axiosInstance.post("contract/approve-agreement/", {
        approval_token: token,
        action: action,
        remarks: remarkValue, 
      });

      if (action === "approved") {
        message.success("Agreement approved successfully ");
        setApproved(true);
      } else {
        message.success("Agreement rejected successfully ");
        setApproved(true);
      }
    } catch (err) {
      console.error(err);
      message.error("Failed to process agreement. Please try again.");
    } finally {
      setLoading(false);
      setIsRejectModalOpen(false); 
      setRemark("");
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-50 p-4">
      <Card 
        className="w-full max-w-md shadow-xl rounded-xl p-8"
        bordered={false}
      >
        <div className="flex flex-col items-center gap-4">
          <Title level={3} className="text-gray-800">Agreement Approval</Title>

          {!approved ? (
            <>
              <Paragraph className="text-center text-gray-600 mb-6">
                Please review and take action on this agreement.
              </Paragraph>

              <div className="flex gap-4 w-full">
                <Button
                  type="primary"
                  icon={<CheckCircleOutlined />}
                  size="large"
                  block
                  className="bg-green-500 border-green-500 hover:bg-green-600"
                  loading={loading}
                  onClick={() => handleApprove("approved")}
                >
                  Approve
                </Button>

                <Button
                  danger
                  icon={<CloseCircleOutlined />}
                  size="large"
                  block
                  loading={loading}
                  onClick={() => setIsRejectModalOpen(true)}
                >
                  Reject
                </Button>
              </div>
            </>
          ) : (
            <div className="flex flex-col items-center gap-3">
              <CheckCircleOutlined style={{ fontSize: 50, color: approved ? "#22c55e" : "#ef4444" }} />
              <Paragraph className={`text-lg font-semibold ${approved ? "text-green-600" : "text-red-600"}`}>
                ✅ Action Completed!
              </Paragraph>
              <Paragraph className="text-gray-500 text-center">
                Thank you for taking action on this agreement.
              </Paragraph>
            </div>
          )}
        </div>
      </Card>

      <Modal
        title="Reject Agreement"
        open={isRejectModalOpen}
        onCancel={() => setIsRejectModalOpen(false)}
        onOk={() => {
          if (!remark.trim()) {
            return message.warning("Please enter a reason for rejection.");
          }
          handleApprove("rejected", remark);
        }}
        confirmLoading={loading}
        okText="Reject"
        okButtonProps={{ danger: true }}
      >
        <p className="mb-2">Please provide a reason for rejecting this agreement:</p>
        <textarea
          rows={4}
          className="w-full border rounded p-2 focus:outline-none focus:ring-2 focus:ring-red-400"
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
          placeholder="Enter your reason..."
        />
      </Modal>
    </div>
  );
};

export default ApproveAgreementPage;
